<template>
    <div style="height: 100%">
        <!--   <b-tabs vertical id="tabsRsaPazienteAreeView" ref="tabsRsaPazienteAreeView" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items sa-tab-items-aree sa-tab-items-vertical" content-class="mt-3" class="sa-tab" style="padding-bottom: 25px" fill @input="onInputTabs"> -->
        <sa-tabs-scroll-component idTab="tabsRsaDiario" classNavItem="nav-item"></sa-tabs-scroll-component>
        <b-tabs id="tabsRsaDiario" ref="tabsRsaDiario" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items"
            content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab v-for="diarioTab in diariTabs" :key="diarioTab.id" :title="diarioTab.nome">
                <div class="sa-accordion-wrapper">
                    <form :key="keyIndex">
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" :name="diarioTab.id + 'radio-a'"
                                :id="diarioTab.id + 'radio-a'" value="1" checked="checked" />
                            <label class="sa-accordion-label" :for="diarioTab.id + 'radio-a'">
                                Diario
                                <b-button v-if="!isDiarioAssistenziale" size="sm"
                                    variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn"
                                    @click="onClickNuovaNota()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi Nota
                                </b-button>
                                <b-button v-if="!isDiarioAssistenziale" size="sm"
                                    variant="outline-purple outline-secondary-noborder pull-right sa-accordion-btn"
                                    @click="onClickStampa()">
                                    <b-icon icon="printer" />
                                    Stampa
                                </b-button>
                            </label>
                            <div class="sa-timeline-diario">
                                <div v-for="voceDiario in vociDiario" :key="voceDiario.id"
                                    :class="getColorAttivita(voceDiario)">
                                    <div class="sa-timeline-diario-event-icon">
                                        <i :class="getIconAttivita(voceDiario)"></i>
                                    </div>

                                    <div class="sa-timeline-diario-event-date">
                                        <div class="sa-timeline-diario-event-date-header">
                                            <span class="sa-timeline-diario-event-date-header-label"
                                                style="display: block">Registrata:</span>
                                            <span class="sa-timeline-diario-event-date-header-data"
                                                style="display: block">{{ formatDateTime(voceDiario.dataOraEsecuzione)
                                                }}</span>
                                            <span class="sa-timeline-diario-event-date-header-label"
                                                style="display: block">Operatore:</span>
                                            <span class="sa-timeline-diario-event-date-header-data"
                                                style="display: block">{{ voceDiario.lastnameCreator }} {{
                                                    voceDiario.firsnameCreator }}</span>
                                        </div>
                                        <div class="sa-timeline-diario-event-date-body"></div>
                                        <div class="sa-timeline-diario-event-date-footer">
                                            <span class="sa-timeline-diario-event-date-footer-label"
                                                style="display: block">Programmata:</span>
                                            <span class="sa-timeline-diario-event-date-footer-data"
                                                style="display: block">{{ formatDateTime(voceDiario.dataOraProgrammata)
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="sa-timeline-diario-event-content">
                                        <div class="sa-timeline-diario-event-content-header">
                                            <div class="sa-timeline-diario-event-title" :style="getStyle(voceDiario)">
                                                {{ voceDiario.tipologia }}
                                            </div>
                                        </div>
                                        <div class="sa-timeline-diario-event-content-body">
                                            <p :style="getStyle(voceDiario)">{{ voceDiario.nome }}</p>
                                            <p v-html="voceDiario.annotazione" :style="getStyle(voceDiario)"></p>
                                        </div>

                                        <div v-if="voceDiario.tipologia === tipologiaDiario"
                                            class="sa-timeline-diario-event-content-footer">
                                            <b-button v-if="btnModificaNota[voceDiario.id]" size="sm"
                                                variant="outline-success outline-secondary-noborder pull-right"
                                                :disabled="isCancellata(voceDiario) || isModificata(voceDiario)"
                                                @click="onClickModifica(voceDiario)">
                                                <i class="bi bi-pencil"></i>
                                                Modifica
                                            </b-button>
                                            <b-button v-if="btnEliminaNota[voceDiario.id]" size="sm"
                                                variant="outline-danger outline-secondary-noborder pull-right"
                                                :disabled="isCancellata(voceDiario) || isModificata(voceDiario)"
                                                @click="onClickCancella(voceDiario)">
                                                <i class="far fa-trash-alt"></i>
                                                Cancella
                                            </b-button>
                                            <span v-if="isCancellata(voceDiario)"
                                                style="padding-top: 3px; float: right; padding-right: 5px; font-style: italic">Cancellato
                                                da {{ voceDiario.firsnameUpdater }} {{ voceDiario.lastnameUpdater }} il
                                                {{ formatDateTime(voceDiario.updateDate) }}</span>
                                            <span v-if="isModificata(voceDiario)"
                                                style="padding-top: 3px; float: right; padding-right: 5px; font-style: italic">Modificata
                                                da {{ voceDiario.firsnameUpdater }} {{ voceDiario.lastnameUpdater }} il
                                                {{ formatDateTime(voceDiario.updateDate) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </b-tab>
        </b-tabs>
        <rsa-diari-note-edit-component ref="cmpRsaDiariNoteEditComponent"
            @afterSaveRequest="onAfterSaveRequestRsaDiariNoteComponent"></rsa-diari-note-edit-component>
        <print-component v-show="false" ref="cmpPrint" :reportName="reportName"
            :printData="printData"></print-component>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RsaDiariNoteEditComponent from "./RsaDiariNoteEditComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import PermessiMixin from "../../../utility/PermessiMixin";
import SaTabsScrollComponent from "../../../../template/components/utility/SaTabsScrollComponent.vue";
import { Permessi } from "../../../utility/PermessiMixin";
export default {
    mixins: [UtilityMixin, PermessiMixin],
    components: { RsaDiariNoteEditComponent, PrintComponent, SaTabsScrollComponent },
    created() {
        /*    let me = this;
        me.loadDiari(); */
        this.user = JSON.parse(sessionStorage.getItem("user"));
    },
    props: {
        //UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "accettazione", 2);
        //jsonDataAccettazione: { type: Object },
    },
    data() {
        return {
            user: {},
            btnPermessiAggiungiNota: false,
            btnModificaNota: {},
            btnEliminaNota: {},
            btnCancellaNota: false,
            activeTabIndex: 0,
            perPage: 100,
            pathResourcesDiari: "/rsadiari/attivi",
            pathResourcesVociDiario: "/rsadiarivoci",
            idUltimoDiarioCaricato: null,
            isLoadingVociDiario: false,
            jsonDataAccettazione: {},
            idDiario: "",
            filtroDiario: {},
            reportName: "",
            printData: {},
            //  linkPrint: "",
            diarioSelezionato: "",
            codiceDiario: "",
            tipologiaDiario: "NOTA",
            diariTabs: [{ nome: "Nessun Diario Disponibile" }],
            vociDiario: [],
            keyIndex: 0,
            fields: [
                {
                    label: "Area",
                    key: "area",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Nome",
                    key: "nomeAttivita",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Tipologia",
                    key: "tipologia",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Data/ora Programmata",
                    key: "dataOraProgrammata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Data/Ora Esecuzione:",
                    key: "dataOraEsecuzione",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                {
                    label: "Annotazione",
                    key: "annotazione",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        //this.verificaPermessi();
    },
    computed: {
        isDiarioAssistenziale() {
            let me = this;
            return me.diariTabs[me.activeTabIndex].idDiario === null;
        },
    },
    methods: {
        verificaPermessi(idRisorsa) {
            PermessiMixin.methods.verificaPermesso("rsadiari", idRisorsa, Permessi.INSERIMENTO, this.verificaPermessiInserimentoSuccess, this.verificaPermessiInserimentoError);
        },
        verificaPermessiInserimentoSuccess(value) {
            this.btnPermessiAggiungiNota = value.data.esito;
        },
        verificaPermessiInserimentoError(error) {
            console.log(error);
        },
        init(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;

            me.loadDiari();
        },
        getStyle(element) {
            let returnValue = {};
            if (element.stato === "CANCELLATA" || element.stato === "MODIFICATA") {
                returnValue = { textDecoration: "line-through" };
            }
            return returnValue;
            //return element.stato === "CANCELLATA" ||element.stato ===  "MODIFICATA" ? { textDecoration: "line-through" } : {};
        },
        isCancellata(element) {
            return element.stato === "CANCELLATA" ? true : false;
        },
        isModificata(element) {
            return element.stato === "MODIFICATA";
        },
        getColorAttivita(item) {
            let returnValue = "sa-timeline-diario-event animated fadeInUp delay-3s ";
            switch (item.tipologia) {
                case "NOTA":
                    if (item.stato == "CANCELLATA") {
                        returnValue += "sa-timeline-diario-event-note";
                    } else {
                        returnValue += "sa-timeline-diario-event-note-type3";
                    }

                    break;
                default:
                    returnValue += item.tipologia === "ESEGUITA" ? "sa-timeline-diario-event-type2" : item.tipologia === "PROGRAMMATA" ? "sa-timeline-diario-event-type3" : "sa-timeline-diario-event-type1";
                    break;
            }

            returnValue = item.stato === "CANCELLATA" ? (returnValue += " sa-timeline-diario-event-cancellata") : returnValue;
            return returnValue;
        },
        getIconAttivita(item) {
            let returnValue = "fas fa-question";
            switch (item.tipologia) {
                case "NOTA":
                    returnValue += "far fa-comment-alt";
                    break;
                case "PROGRAMMATA":
                    returnValue += "fas fa-calendar-day";
                    break;
                default:
                    returnValue += item.tipologia === "ESEGUITA" ? "fas fa-check" : "fas fa-question";
            }

            return returnValue;
        },
        loadDiari() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesDiari;
            let filtro = { idPresidio: me.jsonDataAccettazione.idPresidio };
            let nuovoDiario = { nome: "DIARIO ASSISTENZIALE", idDiario: null };
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.diariTabs = response.data.data.list;
                    me.diarioSelezionato = me.diariTabs[0].nome;
                    me.idDiario = me.diariTabs[0].id;
                    me.codiceDiario = me.diariTabs[0].codiceDiario;
                    me.diariTabs.unshift(nuovoDiario);
                    me.loadVociDiario();
                })
                .catch((err) => {
                    let messaggio = err.response.data.messaggio ? err.response.data.messaggio : "Errore durante il caricamento";
                    me.$bvToast.toast(messaggio, {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        loadVociDiario() {
            let me = this;
            let diarioIdCorrente = me.diariTabs[me.activeTabIndex].id;

            /*  if (me.isLoadingVociDiario || me.idUltimoDiarioCaricato === diarioIdCorrente) {
                return;
            }
            me.isLoadingVociDiario = true; */

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesVociDiario;
            me.diarioSelezionato = this.diariTabs[me.activeTabIndex].nome;
            me.idDiario = diarioIdCorrente;
            me.verificaPermessi(me.idDiario);
            if (sessionStorage["filtroDiario"]) {
                me.filtroDiario = JSON.parse(sessionStorage["filtroDiario"]);
                this.$emit("updateFilter", me.filtroDiario);
            }
            let filtro = { ...me.filtroDiario, idAccettazione: me.jsonDataAccettazione.id, idDiario: me.idDiario };
            this.btnModificaNota = {};
            this.btnEliminaNota = {};
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.vociDiario = response.data.data.list;
                    me.vociDiario.forEach((element) => {
                        this.btnModificaNota[element.id] = this.verificaProprietario(element.proprietario);
                        this.btnEliminaNota[element.id] = this.verificaProprietario(element.proprietario);
                    });
                    me.keyIndex++;
                    me.idUltimoDiarioCaricato = me.idDiario;
                    me.isLoadingVociDiario = false;
                    me.loadStampeReport();
                })
                .catch(() => {
                    me.isLoadingVociDiario = false;
                });
        },
        onInputTabs() {
            let me = this;
            me.loadVociDiario();
        },
        onClickNuovaNota() {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" || me.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                me.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else
                me.$refs.cmpRsaDiariNoteEditComponent.add({
                    id: null,
                    codiceDiario: me.codiceDiario,
                    dataOraEsecuzione: new Date().getTime(),
                    dataOraProgrammata: new Date().getTime(),
                    idAccettazione: me.jsonDataAccettazione.id,
                    idDiario: me.idDiario,
                    idPaziente: me.jsonDataAccettazione.accettazioneAnagrafica.id,
                    nome: "NOTA",
                    tipologia: "NOTA",
                    tipoRiga: null,
                });
        },
        onClickStampa() {
            let me = this;
            me.$refs.cmpPrint.onPrint();
        },
        loadStampeReport() {
            let me = this;
            console.log("STAMPA REPORT DIARIO ?");

            let path = "/rsadiarivoci/printdata/" + me.idDiario;
            me.loadDataResources(path, { idAccettazione: me.jsonDataAccettazione.id, dataOraInizio: me.filtroDiario.dataOraFine, dataOraFine: me.filtroDiario.dataOraFine }, me.resultResponseStampa, me.resultErrorStampa);
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = response.data.data.reportName;
            me.printData = response.data.data;
            if (me.printData.data.details) {
                me.printData.data.details.sort((a, b) => a["createDate"] - b["createDate"]);
            }
        },
        resultErrorStampa(error) {
            console.log(error);
        },
        onAfterSaveRequestRsaDiariNoteComponent() {
            let me = this;
            me.loadVociDiario();
        },
        onClickModifica(item) {
            let me = this;

            me.$refs.cmpRsaDiariNoteEditComponent.modificaNota(item.id);
        },
        onClickCancella(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Ricetta",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteNota(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteNota(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesVociDiario + "/logicdelete/" + id;
            axios
                .delete(link)
                .then(() => {
                    me.showModalLoading = false;
                    me.loadDiari();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        resetAndReloadVoci() {
            let me = this;
            me.idUltimoDiarioCaricato = null;
            me.isLoadingVociDiario = false;
            me.loadVociDiario();
        },
    },
};
</script>
<style scoped>
.sa-timeline-diario-event-note-type3 .sa-timeline-diario-event-icon {
    /*   background-color: #aff1b6;
    color: #24b47e; */
    /* background-color: #00a3ff;
     */

    background-color: #00c1d3;
    color: #00838f;
}

.sa-timeline-diario-event-note .sa-timeline-diario-event-icon {
    /*   background-color: #aff1b6;
    color: #24b47e; */
    /* background-color: #00a3ff;
     */

    background-color: #c5c5c5;
    color: #ffffff;
}

/*
.sa-timeline-diario-event-note .sa-timeline-diario-event-icon::before {
    background-color: #aff1b6;
}
.sa-timeline-diario-event-note .sa-timeline-diario-event-icon::after {
    background-color: #aff1b6;
}
.sa-timeline-diario-event.sa-timeline-diario-event-note:nth-child(2n + 1) .sa-timeline-diario-event-icon::before {
    background-color: #aff1b6;
}
.sa-timeline-diario-event.sa-timeline-diario-event-note:nth-child(2n + 1) .sa-timeline-diario-event-icon::after {
    background-color: #aff1b6;
} */
.sa-timeline-diario-event-note-type3 .sa-timeline-diario-event-icon .icon-cancellata {
    background-color: red;
}

.sa-timeline-diario-event-note-type3 .sa-timeline-diario-event-date {
    /*    background-color: #24b47e;
    color: #fafafa; */
    /* background-color: #00a3ff; */
    background-color: #00838f;
    color: #fafafa;
}

.sa-timeline-diario-event-note.sa-timeline-diario-event-cancellata .sa-timeline-diario-event-date {
    /*    background-color: #24b47e;
    color: #fafafa; */
    background-color: #777777;
    color: #fafafa;
}

.sa-timeline-diario-event-note-type3 .sa-timeline-diario-event-title {
    /*   color: #24b47e;*/
    color: #00838f;
}

/**------------------------------------------------------------------- */
.sa-timeline-diario-event-type1 .sa-timeline-diario-event-title {
    color: red;
}

.sa-timeline-diario-event-type3 .sa-timeline-diario-event-title {
    color: #00a3ff;
}

.sa-timeline-diario-event-type2 .sa-timeline-diario-event-title {
    color: green;
}

.sa-timeline-diario-event-cancellata .sa-timeline-diario-event-title {
    color: #777777;
}

/* */

.sa-timeline-diario-event-type3 .sa-timeline-diario-event-date {
    background-color: #00a3ff;
    color: #fafafa;
}

.sa-timeline-diario-event-type1 .sa-timeline-diario-event-date {
    background-color: rgb(245, 69, 69);
    color: #fafafa;
}

.sa-timeline-diario-event-type2 .sa-timeline-diario-event-date {
    /*    background-color: #00a3ff;
    color: #fafafa;
    background-color: #97d9ff;
    color: #fafafa; */
    background-color: #24b47e;
    color: #fafafa;
}

.sa-timeline-diario-event-type1 .sa-timeline-diario-event-icon {
    /*   background-color: #dd8b8b;
    color: red; */
    /*   background-color: #f54545;
    color: #fafafa; */
    background-color: #ff8080;
    /*    color: #f54545; */
    color: red;
}

.sa-timeline-diario-event-type2 .sa-timeline-diario-event-icon {
    /*    background-color: #aff1b6;
    color: #24b47e; */
    /*     background-color: #97d9ff;
    color: #fafafa; */
    background-color: #aff1b6;
    color: #24b47e;
}

.sa-timeline-diario-event-type3 .sa-timeline-diario-event-icon {
    /*    background-color: #aff1b6;
    color: #24b47e; */
    /*     background-color: #97d9ff;
    color: #fafafa; */
    background-color: #00a2ff5e;
    color: #00a3ff;
}

.sa-timeline-diario-event-cancellata .sa-timeline-diario-event-icon {
    background-color: #777777;
}
</style>
